export default {
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$oauthInitSession();
        });
    }
}